import React, { useEffect, useState } from 'react'
import { Container, Switch } from "@bsf/force-ui";
import apiFetch from '@wordpress/api-fetch';
import { __ } from '@wordpress/i18n';

// Create a queue to manage AJAX requests
const requestQueue = [];

const processQueue = () => {
    if (requestQueue.length === 0) return;

    // Take the first item from the queue and run it
    const currentRequest = requestQueue.shift();
    currentRequest();
};

const PostWidgetItem = ({
    widget,
    updateCounter
}) => {
    const {
        id,
        image,
        title,
    } = widget

    // Track the active state of the widget using React state
    const [isActive, setIsActive] = useState(widget.is_active);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsActive(widget.is_active);
    }, [widget.is_active, updateCounter]);

    const apiCall = (activateWidget) => {
        const action = activateWidget ? 'uael_deactivate_widget' : 'uael_activate_widget';

        const formData = new window.FormData();
        formData.append('action', action);
        formData.append('nonce', uaelSettingsData.ajax_nonce);
        formData.append('module_id', id);

        try {
            const data = apiFetch({
                url: uaelSettingsData.ajax_url,
                method: 'POST',
                body: formData,
            });

            if (data.success) {
                setIsActive(isActive);  // Update the active state after the request
            } else if (data.error) {
                // console.log('AJAX request failed');
            }
        } catch (err) {
            // console.log("Error during AJAX request");
        } finally {
            setIsLoading(false);  // Always stop the loading spinner
            processQueue();
        }
    }

    const handleSwitchChange = () => {
        if (isLoading) return;

        setIsLoading(true);

        if (isActive) {
            // Add the request to the queue
            setIsActive(false);
            requestQueue.push(() => apiCall(isActive));
        } else {
            // Add the request to the queue
            setIsActive(true);
            requestQueue.push(() => apiCall(isActive));
        }

        // Update the active state immediately
        if (requestQueue.length === 1) {
            // Start processing the queue if no other request is being processed
            processQueue();
        }
    };

    return (
        <Container align="center"
            containerType="flex"
            direction="row"
            justify="between"
            gap=""
        >
            <div className='flex flex-col w-full'>
                <div className='flex items-center justify-between w-full'>
                    <p className='text-sm font-medium text-text-primary pt-3 m-0 pb-1'>{title}</p>
                    <div className='flex items-center'>
                        <Switch
                            onChange={handleSwitchChange}
                            size='sm'
                            value={isActive}
                        />
                    </div>
                </div>
                <img
                    src={image}
                    alt="Custom SVG"
                    className="mt-2"
                />
            </div>
        </Container>
    )
}

export default PostWidgetItem